'use client';

import Link from 'next/link';
import { trackClick } from '@/lib/analytics';

export default function BackNavigationLinkTracked({ href }: { href: string }) {
  return (
    <Link
      href={href}
      prefetch={false}
      onClick={() => trackClick('back_navigation_button_click')}
      className='mr-4 rounded-full p-1 text-gray-600 transition-colors duration-200 hover:bg-gray-100 hover:text-gray-800'
      aria-label='Go back'
    >
      <span className='text-2xl leading-none'>&larr;</span>
    </Link>
  );
}
